import util from '@bmp-vue/core/api/util'

const controller = 'ContaCorrenteLog'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'put', 'post']), {})

